/**
 * Ryan O'Dowd
 * 2024-03-01
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    minigamesWrapper: {
      flexDirection: 'column', // @TODO: would like these to be listed in multiple columns, but that can come later
      alignItems: 'flex-start',
    },
    errorText: {
      color: colors.alert,
    },
    passageSelectionWrapper: {
      flexDirection: 'column',
    },
    memorizationSettings: {
      flexDirection: 'column',
    },
    selectButtonWrapper: {
      flex: 1,
      width: 'fit-content',
      marginTop: globalScale * 8,
      marginHorizontal: globalScale * 4,
    },
    adminSettingsWrapper: { // @TODO: abstract with other components
      backgroundColor: colors.primaryExtraLight,
      minWidth: 500,
    },
    adminOptionsInner: { // @TODO: abstract with other components
      flex: 1,
    },
  };
};

export default getStyles;
